import { MyLinksLayout } from '../MyLinks.styles';
import { Typography, Box } from '@material-ui/core';
import { PublicProfileLinksHeader } from './PublicProfileLinks.styles';
import { IMyLinkTalentInfo } from '../types';
import FieldContent from './FieldContent/FieldContent';
import ProfileList from './ProfileList/ProfileList';
import { memo } from 'react';

const PublicProfileLinks = ({ talentInfo, changeSlug }: { talentInfo: IMyLinkTalentInfo; changeSlug: Function }) => {
  return (
    <MyLinksLayout
      marginTop={'10px'}
      noPaddingInline={true}
      style={{
        opacity: talentInfo?.talent_public_active_link ? 1 : 0.2,
        pointerEvents: talentInfo?.talent_public_active_link ? undefined : 'none',
      }}
    >
      <PublicProfileLinksHeader paddingX={'20px'}>
        <Typography style={{ fontSize: 16 }}>Public Profile Links</Typography>
      </PublicProfileLinksHeader>
      <Box style={{ padding: '20px 20px' }}>
        <PublicProfileLinksHeader>
          <Typography style={{ fontSize: '14px' }}>
            Below are the shareable links for your profiles. Once activated, your profile will be visible to anyone with
            the link. Each profile has its own unique link, allowing you to share specific profiles directly or on
            social media.
          </Typography>
        </PublicProfileLinksHeader>
        <FieldContent
          talent_slug={talentInfo?.talent_slug}
          talent_country_code={talentInfo?.talent_country_code}
          changeSlug={changeSlug}
        />
        <ProfileList talentInfo={talentInfo} />
      </Box>
    </MyLinksLayout>
  );
};

export default memo(PublicProfileLinks);
